module.exports = __webpack_public_path__ + "img/dark_box2_tag3.9835b367.png";